import { useQuery } from '@apollo/client';
import { useSession } from '@/components/session/useSession';
import { GET_NOTIFICATIONS } from '../../graphql/Users.queries';
import NotificationsPopover from './NotificationsPopover';

function Notifications() {
  const { user } = useSession();

  const { data } = useQuery(GET_NOTIFICATIONS, {
    variables: {
      user_id: user.id,
    },
    pollInterval: 5 * 60 * 1000, // 5 minutes
  });

  return <NotificationsPopover notifications={data?.notification ?? []} />;
}

export default Notifications;
